<template>
  <section class="content">
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">{{'merchant_points' | translate}}</h3>
      </div>
        <div class="box-body">
          <p>{{'merchant_points_text' | translate}}</p>
          <a :href="pointsLink.path" download class="btn btn-success" target="_blank"><i class="fa fa-cloud-download mr-5"></i>Download</a>
        </div>
        <div class="box-footer"></div>
    </div>
  </section>
</template>
<script>

export default {
  data () {
    return {
      pointsLink: {}
    }
  },
  methods: {
    refresh () {
      API.get('/statistics/merchant-points')
        .then(response => {
          this.pointsLink = response.data
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.refresh()
    })
  }
}
</script>
<style>
    select option.normal{
        margin:40px;
        color:#fff;
        text-shadow:0 1px 0 rgba(0,0,0,.4);
        background:#202227
    }
    .picker:not(.month-year-label) {
        background: #212228;
    }
    .picker > .flexbox:not(.monthItem) {
        background-color: rgba(0,195,150,.075);
        border-color: #00C396;
        color: #00C396;
        font-weight: 600;
    }
    .picker > .flexbox.monthItem {
        background-color: #212228 ;
        color: white;
        font-weight: 600;
        border-top: 1px solid rgba(255,255,255, .15) !important;
    }
    .picker .monthItem .item:hover {
        background-color: #00C396 !important;
    }
    .date-popover{
        background: none !important;
        border: 1px solid rgba(255,255,255, .15) !important
    }
</style>
<style scoped>
    span.italic {
        font-style: italic;
        word-wrap: break-word;
    }
    hr {
        margin-top: 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Downloads/Points.vue